import { createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, normalizeStyle as _normalizeStyle, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "container-9" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "sm:col-span-1" }, null, -1)
const _hoisted_3 = { class: "sm:col-span-5 main-content text-3xl" }
const _hoisted_4 = { class: "flex flex-col flex-1" }
const _hoisted_5 = {
  key: 0,
  class: "question-label"
}
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = ["innerHTML"]
const _hoisted_9 = { class: "justify-items-stretch flex flex-col slider-pink w-full mt-auto p-2 text-project text-2xl" }
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = ["innerHTML"]
const _hoisted_13 = ["innerHTML"]
const _hoisted_14 = { class: "mb-4 w-full" }
const _hoisted_15 = ["innerHTML"]
const _hoisted_16 = {
  key: 1,
  class: "mt-16 mb-8 w-full"
}
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["placeholder"]
const _hoisted_19 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Slider = _resolveComponent("Slider")!
  const _component_BackNextButtons = _resolveComponent("BackNextButtons")!
  const _component_ScreenWrapper = _resolveComponent("ScreenWrapper")!
  const _directive_t = _resolveDirective("t")!

  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["screen-content", _ctx.config.classes?.wrapperClasses])
  }, [
    _createVNode(_component_ScreenWrapper, {
      "class-name": "pt-0",
      next: _ctx.next,
      screen: _ctx.screen,
      "hide-arrow": ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _hoisted_2,
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              (_ctx.config.title)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _withDirectives(_createElementVNode("span", null, null, 512), [
                      [_directive_t, _ctx.config.title]
                    ])
                  ]))
                : _createCommentVNode("", true),
              (_ctx.config.textPart1)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 1,
                    class: "mt-4",
                    innerHTML: _ctx.$rt(_ctx.config.textPart1, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_6))
                : _createCommentVNode("", true),
              (_ctx.config.textPart2)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 2,
                    class: "mt-8",
                    innerHTML: _ctx.$t(_ctx.config.textPart2, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_7))
                : _createCommentVNode("", true),
              (_ctx.config.textPart4)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 3,
                    class: "mt-8",
                    innerHTML: _ctx.$t(_ctx.config.textPart4, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_8))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("p", {
                  class: "mt-8",
                  innerHTML: _ctx.$t(_ctx.firstQuestion.question, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_10),
                (_ctx.config.sliderSubtext)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 0,
                      class: "text-sm",
                      innerHTML: _ctx.$rt(_ctx.config.sliderSubtext)
                    }, null, 8, _hoisted_11))
                  : _createCommentVNode("", true),
                _createVNode(_component_Slider, {
                  class: "w-full",
                  alternate: false,
                  min: _ctx.config.answerMin,
                  max: _ctx.config.answerMax,
                  step: _ctx.config.answerStep,
                  value: _ctx.state.answers.value?.[`${_ctx.config.answerKey}.${_ctx.firstQuestion.key}`],
                  unit: _ctx.$t(_ctx.config.answerUnit, {name: _ctx.state.nickname.value}),
                  onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.answer(_ctx.firstQuestion.key, $event, { [`${_ctx.config.answerKey}.${_ctx.firstQuestion.key}`]: _ctx.$t(_ctx.firstQuestion.question) }))),
                  options: _ctx.config.answerOptions
                }, null, 8, ["min", "max", "step", "value", "unit", "options"])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.otherQuestions, ({question, key}, index) => {
              return (_openBlock(), _createElementBlock("div", {
                key: key,
                class: _normalizeClass(["justify-items-stretch flex flex-col slider-pink w-full mt-8 p-2 pb-8 text-project text-2xl", {'bg-gray-100': index %2 == 0}])
              }, [
                _createElementVNode("p", {
                  class: "mt-4",
                  innerHTML: _ctx.$t(question, {name: _ctx.state.nickname.value})
                }, null, 8, _hoisted_12),
                (_ctx.config.sliderSubtext)
                  ? (_openBlock(), _createElementBlock("small", {
                      key: 0,
                      class: "text-sm",
                      innerHTML: _ctx.$rt(_ctx.config.sliderSubtext)
                    }, null, 8, _hoisted_13))
                  : _createCommentVNode("", true),
                _createVNode(_component_Slider, {
                  class: "w-full",
                  alternate: false,
                  min: _ctx.config.answerMin,
                  max: _ctx.config.answerMax,
                  step: _ctx.config.answerStep,
                  value: _ctx.state.answers.value?.[`${_ctx.config.answerKey}.${key}`],
                  unit: _ctx.$t(_ctx.config.answerUnit, {name: _ctx.state.nickname.value}),
                  onChange: ($event: any) => (_ctx.answer(key, $event, { [`${_ctx.config.answerKey}.${key}`]: _ctx.$t(question) })),
                  options: _ctx.config.answerOptions
                }, null, 8, ["min", "max", "step", "value", "unit", "onChange", "options"])
              ], 2))
            }), 128)),
            _createElementVNode("div", _hoisted_14, [
              (_ctx.config.textPart3)
                ? (_openBlock(), _createElementBlock("p", {
                    key: 0,
                    class: "mt-4",
                    innerHTML: _ctx.$t(_ctx.config.textPart3, {name: _ctx.state.nickname.value})
                  }, null, 8, _hoisted_15))
                : _createCommentVNode("", true),
              (_ctx.config.additionalOptionsText)
                ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                    _createElementVNode("p", {
                      class: "mt-4 text-project text-2xl",
                      innerHTML: _ctx.$t(_ctx.config.additionalOptionsText, {name: _ctx.state.nickname.value})
                    }, null, 8, _hoisted_17),
                    _withDirectives(_createElementVNode("textarea", {
                      class: "border border-gray-300 rounded-md bg-gray-100 p-2 text-sm w-full",
                      rows: "2",
                      placeholder: _ctx.config.additionalOptionsPlaceholder ? _ctx.$t(_ctx.config.additionalOptionsPlaceholder, {name: _ctx.state.nickname.value}): '',
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.additional) = $event))
                    }, null, 8, _hoisted_18), [
                      [_vModelText, _ctx.additional]
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_BackNextButtons, {
              class: "mt-8",
              "go-to": _ctx.goToWithSave,
              "next-screen": _ctx.config.screenNext
            }, null, 8, ["go-to", "next-screen"])
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["sm:col-span-3 h-full min-h-50vh flex flex-col items-center justify-start", _ctx.config.classes.rightSide])
          }, [
            (_ctx.config.bgImage)
              ? (_openBlock(), _createElementBlock("div", {
                  key: 0,
                  class: "bg-project w-full aspect-square flex flex-col items-center justify-center",
                  style: _normalizeStyle(_ctx.config.bgStyles)
                }, [
                  _createElementVNode("img", {
                    src: _ctx.config.bgImage,
                    class: _normalizeClass(["w-full", _ctx.config.classes?.bgImageClasses]),
                    alt: "Logo"
                  }, null, 10, _hoisted_19)
                ], 4))
              : _createCommentVNode("", true)
          ], 2)
        ])
      ]),
      _: 1
    }, 8, ["next", "screen"])
  ], 2))
}